import React from "react";
import {Card, Col, Row} from "antd";
import {PieChart} from "../../../../../components/_defaultComponents/Charts/PieChart/PieChart";
import {ColorMarker} from "./pieReportWidgetStyle";

export const PieReportWidget = ({data, loading = true, title = "", unitLabel = ""}) => {
    return (
        <Card loading={loading} style={{height: "100%", width: "100%"}}>
            {title && <Row>{title}</Row>}
            <Row justify="middle" align="top">
                <Col span={10} justify="start">
                    <PieChart data={data} />
                </Col>
                <Col span={14} align="bottom">
                    {data.map((item, i) => (
                        <Row key={i} align="middle" justify="stretch">
                            <ColorMarker color={item.color} />
                            {item.name}:<b style={{paddingLeft: 6}}>{item.value}</b>
                            <span style={{paddingLeft: 2}}>{unitLabel}</span>
                        </Row>
                    ))}
                </Col>
            </Row>
        </Card>
    );
};
